export default "__VITE_ASSET__DYFoW_LV__"